// src/components/NotFound/index.js
import React, { Component } from 'react';
import AdminHeader from '../AdminHeader';
import Auth from '../../service/auth';
var BaseService = require('../../service/baseservice');
import FlatButton from 'material-ui/FlatButton';
import {Tabs, Tab} from 'material-ui/Tabs';
import LoadingIndicator from '../shared/LoadingIndicator';
import CategoryRow from './CategoryRow';
import CategoryLetterTab from './CategoryLetterTab';
import CategoryEditDialog from './CategoryEditDialog';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';

import './style.css';

var newCategory = {
  _id: "",
  name: "",
  officialName:"",
  searchTerms:""
};

export default class CategoriesPage extends Component {

  state = {
    dialogOpen: false,
    category: newCategory,
    categoryIndex: -1,
    selectedLetter: 'A',
    categories: []
  };

  dataUpdated(data) {
    this.categoriesFetched(data.categories);
  }

  componentDidMount() {
    BaseService.addListener(this.dataUpdated.bind(this));

    if (BaseService.fetchedData.categories.length > 0) {
        this.categoriesFetched(BaseService.fetchedData.categories);
    }
  }

  categoriesFetched(categories) {
    var letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "Å", "Ä", "Ö"];

    var dataDictionary = {};
    for (let letter in letters) {
      if (letter != null) {
        dataDictionary[letters[letter]] = [];
      }
    }

    for (var categoryIdx in categories) {
      if (categories[categoryIdx] != null) {
        var category = categories[categoryIdx];
        let char = category.friendlyName ? category.friendlyName.charAt(0) : category.name.charAt(0);
        char = char.toUpperCase();

        let array = dataDictionary[char];
        array.push(category);
        dataDictionary[char] = array;
      }
    }

    this.setState({'categories': dataDictionary});
  }

  handleClose = () => {
    this.setState({dialogOpen: false});
  };

  handleSaveChanges = () => {
    this.setState({dialogOpen: false});
    console.log("new values" + JSON.stringify(this.state.category));
  }

  onCategorySelected(selected) {
    let newState = {
      dialogOpen:true,
      categoryIndex: selected,
      category: this.state.categories[this.state.selectedLetter][selected]
    };

    this.setState(newState);
  }

  onTabSelected(letter) {
    this.setState({selectedLetter:letter});
  }

  createNewClicked() {
    this.setState({dialogOpen:true, category: newCategory})
  }

  render() {
    var content = <LoadingIndicator/>;

    if (BaseService.fetchedData.categories.length > 0) {
      var dataDictionary = this.state.categories;
      var tabs = Object.keys(dataDictionary).map(letter => {
          var categories = dataDictionary[letter];
          var rows = categories.map( (category, index) => {
            return <CategoryRow key={category._id} category={category} onCategorySelected={(index) => this.onCategorySelected(index)}/>
          });

          var tabContent = "";
          if (this.state.selectedLetter === letter) {
            tabContent = <CategoryLetterTab key={letter} letter={letter} onRowSelection={(row) => this.onCategorySelected(row)} rows={rows}/>
          }

          return (
            <Tab key={letter} label={letter} value={letter}>
              {tabContent}
            </Tab>);
          });

          content =
              <Tabs style={{marginTop: '20px'}} value={this.state.selectedLetter} onChange={(selectedTab) => this.onTabSelected(selectedTab)}>
                  {tabs}
                </Tabs>;
        }

    return (
      <div>
        <AdminHeader selected="categories"/>
          <Toolbar style={{backgroundColor: 'white', borderBottom: '1px rgba(232, 232, 232, 1) solid'}}>
            <ToolbarGroup>
                <FlatButton label="Luo uusi toimiala" onTouchTap={() => this.createNewClicked()} style={{marginLeft:"10px"}} primary={true}/>
            </ToolbarGroup>
          </Toolbar>
        <div className="main-container">
          {content}
        </div>
        <CategoryEditDialog
          enabled={this.state.dialogOpen}
          handleClose={() => this.handleClose()}
          category={this.state.category}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CategoriesPage/CategoriesPage.js